import { render, staticRenderFns } from "./MsTagbox.vue?vue&type=template&id=4ad54bb0"
import script from "./MsTagbox.vue?vue&type=script&lang=js"
export * from "./MsTagbox.vue?vue&type=script&lang=js"
import style0 from "./MsTagbox.vue?vue&type=style&index=0&id=4ad54bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports